import image1 from '../assets/servicesConfigImage1.jpg';
// import videoPoster from "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&h=800&fit=crop";

export const blurb5Config   = {

      heading: "Services",
      services: [
        {
          title: "Promotional Material",
          description: "Website, Flyers, Posters - Complete marketing packages to promote your event"
        },
        {
          title: "Show Production",
          description: "Sound, Video, Photography - Professional production services for any scale event"
        },
        {
          title: "Host",
          description: "Hosted shows involve professional videotaping of the event with full editing suite"
        }
      ],
      buttonText: "See All Services",
      image: image1

};